import React, { Component } from 'react';
import './App.css';
import Image_fill from './Image_fill';
import img_state0_elImage from './images/Image_fill_elImage_back_1322448678.png';
import btn_icon_405901650 from './images/btn_icon_405901650.png';
import btn_icon_644677 from './images/btn_icon_644677.png';
import img_state0_elBig_image from './images/Image_fill_elImage_back_1322448678.png';
import btn_icon_1509691112 from './images/btn_icon_1509691112.png';
import btn_icon_212082506 from './images/btn_icon_212082506.png';
import Apercu from './Apercu';
import btn_icon_708131851 from './images/btn_icon_708131851.png';

// UI framework component imports
import Select from 'muicss/lib/react/select';
import Option from 'muicss/lib/react/option';
import Input from 'muicss/lib/react/input';
import Button from 'muicss/lib/react/button';
import Appbar from 'muicss/lib/react/appbar';

export default class DétailVidageScreen extends Component {

  // Properties used by this component:
  // appActions, deviceInfo, state, type, color

  constructor(props) {
    super(props);
    
    this.state = {
      state0_elExutoireCopy: (<div>Avez-vous vidé le contenant ?</div>),
      state0_elExutoireCopy_plainText: "Avez-vous vidé le contenant ?",
      state0_elId_scan1649174831: (<div> </div>),
      state0_elId_scan1649174831_plainText: " ",
      exutoire_select: '',
      state0_elErase_visible: false,
      state0_elCapture_visible: true,
      tonnage: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_tonnage'] : '') || '',
      commentaire: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_commentaire'] : '') || '',
      state0_elBig_image_visible: false,
      state0_elNotif815668831: (<div> </div>),
      state0_elNotif815668831_plainText: " ",
      state0_elTonnage_fg_visible: false,
      tonnage_fg: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_tonnage'] : '') || '',
      state0_elCommentaire_fg_visible: false,
      commentaire_fg: (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_commentaire'] : '') || '',
      state0_elSave_input_visible: false,
      state1_elExutoireCopy: (<div>Transfert effectué</div>),
      state1_elExutoireCopy_plainText: "Transfert effectué",
      state1_elId_scan1649174831: (<div> </div>),
      state1_elId_scan1649174831_plainText: " ",
      state1_elNotif815668831: (<div> </div>),
      state1_elNotif815668831_plainText: " ",
    };
  }

  componentDidMount() {
    
    let mobileCheckTonnage = () => {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      check = window.matchMedia("(orientation: landscape)").matches && check;
      if (check && !this.state.state0_elTonnage_fg_visible) {
        this.setState({
          state0_elTonnage_fg_visible: true,
          state0_elSave_input_visible: true,
        })
        document.querySelector(".state0_elTonnage_fg").focus();
      }
    };
    let tonnage_element = document.querySelector(".state0_elTonnage");
    if (tonnage_element) {tonnage_element.addEventListener("click", mobileCheckTonnage)}
    
    let mobileCheckCommentaire = () => {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      check = window.matchMedia("(orientation: landscape)").matches && check;
      if (check && !this.state.state0_elCommentaire_fg_visible) {
        this.setState({
          state0_elCommentaire_fg_visible: true,
          state0_elSave_input_visible: true,
        })
        document.querySelector(".state0_elCommentaire_fg").focus();
      }
    };
    let commentaire_element = document.querySelector(".state0_elCommentaire");
    if (commentaire_element) {commentaire_element.addEventListener("click", mobileCheckCommentaire)};
    
    let selected_command = this.props.appActions.dataSlots['ds_selected_command'];
    this.setState({
      exutoire_select: (selected_command.exutoire_realise || selected_command.exutoire).document_key,
    });
    
    if (this.state.state0_elCapture_visible && this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        state0_elCapture_visible: false,
        state0_elErase_visible: true,
      })
    } else if (!this.state.state0_elCapture_visible && !this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        state0_elCapture_visible: true,
        state0_elErase_visible: false,
      })
    }
    
    {
      let dataSheet = this.props.appActions.dataSheets['exutoires'];
      let serviceOptions = this.props.appActions.serviceOptions_exutoires;
      if ( !this.props.appActions.dataSheetLoaded['exutoires']) {
        serviceOptions.servicePath = dataSheet.expandSlotTemplateString("entreprises/$slot('ds_entreprise_id')/exutoires/", this.props.appActions.dataSlots);
        this.props.appActions.loadData_pointapp2(dataSheet, serviceOptions, true);
        this.props.appActions.dataSheetLoaded['exutoires'] = true;
      }
    }
    {
      let dataSheet = this.props.appActions.dataSheets['reference_containers'];
      let serviceOptions = this.props.appActions.serviceOptions_reference_containers;
      if ( !this.props.appActions.dataSheetLoaded['reference_containers']) {
        serviceOptions.servicePath = dataSheet.expandSlotTemplateString("entreprises/$slot('ds_entreprise_id')/all_containers", this.props.appActions.dataSlots);
        this.props.appActions.loadData_pointapp2(dataSheet, serviceOptions, true);
        this.props.appActions.dataSheetLoaded['reference_containers'] = true;
      }
    }
    {
      let dataSheet = this.props.appActions.dataSheets['quaiView'];
      let serviceOptions = this.props.appActions.serviceOptions_quaiView;
      if ( !this.props.appActions.dataSheetLoaded['quaiView']) {
        serviceOptions.servicePath = dataSheet.expandSlotTemplateString("entreprises/$slot('ds_entreprise_id')/quaiView", this.props.appActions.dataSlots);
        this.props.appActions.loadData_pointapp2(dataSheet, serviceOptions, true);
        this.props.appActions.dataSheetLoaded['quaiView'] = true;
      }
    }
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
    if (this.state.state0_elCapture_visible && this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        state0_elCapture_visible: false,
        state0_elErase_visible: true,
      })
    } else if (!this.state.state0_elCapture_visible && !this.props.appActions.dataSlots['ds_saved_picture']) {
      this.setState({
        state0_elCapture_visible: true,
        state0_elErase_visible: false,
      })
    }
  }

  // --- Functions for component state index 0 (1 of 2) --- 
  
  pickerValueChanged_state0_elExutoire_select = (event) => {
    this.setState({exutoire_select: event.target.value});
  }
  
  onClick_state0_elImage = (ev) => {
    this.setState({state0_elBig_image_visible: true});
  
  }
  
  
  onClick_state0_elErase = (ev) => {
    let newVal = "";
    this.props.appActions.updateDataSlot('ds_saved_picture', newVal);
  
  }
  
  
  onClick_state0_elCapture = (ev) => {
    // Go to screen 'Appareil photo'
    this.props.appActions.goToScreen('appareilPhoto', { transitionId: 'fadeIn' });
  
  }
  
  
  textInputChanged_state0_elTonnage = (event) => {
    this.setState({tonnage: event.target.value});
    
    this.props.appActions.updateDataSlot("ds_tonnage", event.target.value);
  }
  
  textInputChanged_state0_elCommentaire = (event) => {
    this.setState({commentaire: event.target.value});
    
    this.props.appActions.updateDataSlot("ds_commentaire", event.target.value);
  }
  
  onClick_state0_elValider = (ev) => {
    if (!this.state.tonnage) {
      window.alert('Veuillez renseigner un tonnage.');
      return;
    }
    
    let a = window.confirm("Confirmer les informations sur le vidage?");
    if (!a) {
      return;
    }
    
    let getExutoire = (document_key) => {
      let output = {'label': '', 'location_key': '', 'document_key': ''};
      let exutoire = this.props.appActions.dataSheets['exutoires'].items.filter(it => it.document_key == document_key)[0];
      if (exutoire) {
        output = {'label': exutoire.label, 'location_key': exutoire.location_key, 'document_key': exutoire.document_key};
      }
      return output;
    }
    
    let ts = new Date();
    ts =  ts.getTime();
    
    let update_ot = {
      commentaire: this.state.commentaire || "",
      coordinates_vidage: {
        lat: window.previousPos.coords.latitude, 
        lng: window.previousPos.coords.longitude,
      },
      document_ref: this.props.appActions.dataSlots['ds_selected_command'].document_ref,
      document_key: this.props.appActions.dataSlots['ds_selected_command'].document_key,
      exutoire_realise: getExutoire(this.state.exutoire_select || this.props.appActions.dataSlots['ds_selected_command'].exutoire.document_key),
      photo: this.props.appActions.dataSlots['ds_saved_picture'],
      statut: 1, // done and ready to validate
      tonnage: parseFloat(this.state.tonnage || 0),
      ts_vidage: ts,
      user_id_vidage: this.props.appActions.dataSlots['ds_userid'],
      user_name_vidage: this.props.appActions.dataSlots['ds_username'],
    }
    
    this.props.appActions.updateDataSlot('ds_selected_command', {...this.props.appActions.dataSlots['ds_selected_command'], ...update_ot});
    this.props.appActions.dataSheets['tournees_j'].replaceItemByRowIndex(update_ot.document_key, update_ot, this.props.appActions.serviceOptions_tournees_j);
    
    let otRow = this.props.appActions.dataSlots['ds_selected_command'];
    let logHistoryMove = () => {
      let ts = new Date();
      ts =  ts.getTime();
      
      let update = {
        commentaire: this.state.commentaire || "",
        coordinates: {
          lat: window.previousPos.coords.latitude, 
          lng: window.previousPos.coords.longitude,
        },
        flux: otRow.flux_realise || otRow.flux_realise,
        id_client: otRow.exutoire_realise.document_key || otRow.exutoire.document_key,
        id_contenant: otRow.container_id || "",
        id_scan: otRow.id_scan || "",
        move_type: "VIDAGE",
        photo: this.props.appActions.dataSlots['ds_saved_picture'],
        reference_ot: otRow.document_key,
        site: otRow.exutoire_realise.label || otRow.exutoire.label,
        tonnage: parseFloat(this.state.tonnage || 0),
        tournee: otRow.tournee,
        ts: ts,
        user_id: this.props.appActions.dataSlots['ds_userid'],
        user_name: this.props.appActions.dataSlots['ds_username']
      };
      this.props.appActions.dataSheets['history_moves'].addItem(update, this.props.appActions.serviceOptions_history_moves);
    }
    logHistoryMove();
    
    /////////////////////////// UPDATE TRUCK LOAD /////////////////
    try {
      let tournee = this.props.appActions.dataSheets['id_tournees_j'].items.find(t => t.document_key == this.props.appActions.dataSlots['ds_selected_command'].tournee);
      let update = {
        document_key: tournee.document_key,
        document_ref: tournee.document_ref,
        loaded_is_full: false
      };
      this.props.appActions.dataSheets['id_tournees_j'].replaceItemByRowIndex(tournee.document_key, update, this.props.appActions.serviceOptions_id_tournees_j);
    } catch (e) {
      console.log(e);
    }
    
    if (otRow.action == 4) {
      window.alert("Attention Vider/Remettre : vous devez retourner poser le contenant chez le client.");
    }
  
    // Go to screen based on value in data slot 'ds_selected_command'
    this.props.appActions.goToScreen(this.targetTable_switchDepot(this.transformTargetScreenValue_switchDepot((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))), { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_state0_elVidage_diff = (ev) => {
    let a = window.confirm("Confirmer le vidage différé?");
    if (!a) {
      return;
    }
    
    let getExutoire = (document_key) => {
      let output = {'label': '', 'location_key': '', 'document_key': ''};
      let exutoire = this.props.appActions.dataSheets['exutoires'].items.filter(it => it.document_key == document_key)[0];
      if (exutoire) {
        output = {'label': exutoire.label, 'location_key': exutoire.location_key, 'document_key': exutoire.document_key};
      }
      return output;
    }
    
    if (true || this.props.appActions.dataSlots['ds_selected_command'].action == 1 || this.props.appActions.dataSlots['ds_selected_command'].action == 4) {
      let update_ot = {
        document_ref: this.props.appActions.dataSlots['ds_selected_command'].document_ref,
        document_key: this.props.appActions.dataSlots['ds_selected_command'].document_key,
        statut: 11,
        commentaire: this.state.commentaire || "",
        exutoire_realise: getExutoire(this.state.exutoire_select || this.props.appActions.dataSlots['ds_selected_command'].exutoire.document_key),
        photo: this.props.appActions.dataSlots['ds_saved_picture'],
        tonnage: parseFloat(this.state.tonnage || 0),
      }
      this.props.appActions.updateDataSlot('ds_selected_command', {...this.props.appActions.dataSlots['ds_selected_command'], ...update_ot});
      this.props.appActions.dataSheets['tournees_j'].replaceItemByRowIndex(update_ot.document_key, update_ot, this.props.appActions.serviceOptions_tournees_j);
    }
    
  
    // Go to screen 'depot v3'
    this.props.appActions.goToScreen('depotV3', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_state0_elBig_image = (ev) => {
    this.setState({state0_elBig_image_visible: false});
  
  }
  
  
  onClick_state0_elCancel1509691112 = (ev) => {
    let a = window.confirm("Interrompre l'OT en cours?");
    if (!a) {
      return;
    }
  
    // Go to screen 'Tournée du jour'
    this.props.appActions.goToScreen('tournéeDuJour', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_state0_elShow_apercu212082506 = (ev) => {
    let newVal = "1";
    this.props.appActions.updateDataSlot('ds_apercu_visible', newVal);
  
  }
  
  
  textInputChanged_state0_elTonnage_fg = (event) => {
    this.setState({tonnage_fg: event.target.value});
    
    this.props.appActions.updateDataSlot("ds_tonnage", event.target.value);
  }
  
  textAreaChanged_state0_elCommentaire_fg = (event) => {
    this.setState({commentaire_fg: event.target.value});
    
    this.props.appActions.updateDataSlot("ds_commentaire", event.target.value);
  }
  
  onClick_state0_elSave_input = (ev) => {
    this.setState({state0_elTonnage_fg_visible: false});
  
    this.setState({state0_elCommentaire_fg_visible: false});
  
    this.setState({state0_elSave_input_visible: !this.state.state0_elSave_input_visible});
  
  }
  
  
  transformTargetScreenValue_switchDepot = (input) => {
    return input.action == 4 ? "VR" : "V";
  }
  
  
  targetTable_switchDepot = (targetId) => {
    if (targetId === 'VR')
      return 'depotV3';
    else if (targetId === 'V')
      return 'tournéeDuJour';
  }
  
  renderState0() {
    let layoutFlowStyle = {};
    let baseStyle = {};
    if (this.props.transitionId && this.props.transitionId.length > 0 && this.props.atTopOfScreenStack && this.props.transitionForward) {
      baseStyle.animation = '0.25s ease-in-out '+this.props.transitionId;
    }
    if ( !this.props.atTopOfScreenStack) {
      layoutFlowStyle.height = '100vh';
      layoutFlowStyle.overflow = 'hidden';
    }
    
    const style_state0_elBackground1042437 = {
      width: '100%',
      height: '100%',
     };
    const style_state0_elBackground1042437_outer = {
      backgroundColor: '#f6f6f6',
     };
    const style_state0_elExutoireCopy = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'center',
     };
    
    const style_state0_elRectangle1463615537 = {
      background: 'rgba(213, 213, 213, 1.000)',
     };
    let transformPropValue_id_scan = (input) => {
      return input.id_scan||"";
    }
    let transformCustomCSSPropValue_id_scan = (input) => {
      let style = '"borderRadius": "5px"';
      try {
        let container = this.props.appActions.dataSheets['reference_containers'].items.find(it => it.id_scan === input.id_scan);
        if (container.unresolved_anomalies_labels.length) {
          style += ',"backgroundColor": "#FFD479"';
        } else {
          if (input.id_scan) {
            style += ',"backgroundColor": "#EBEBEB"';
          }
        } 
      } catch (e) {
        if (input.id_scan) {
          style += ',"backgroundColor": "#EBEBEB"';
        }
      }
      
      return style;
    }
    
    const value_id_scan = transformPropValue_id_scan((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_state0_elId_scan1649174831 = {
      color: 'rgba(0, 0, 0, 0.5000)',
      textAlign: 'center',
      ...(() => {  // append customCSS property of 'id_scan'
        let val = transformCustomCSSPropValue_id_scan((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
        if (val == null || val.length == 0) return null;
        try {
          return JSON.parse('{'+val+'}');
        } catch (error) {
          console.log(error);
        }
        return null;
      })(),
     };
    
    let transformValue_state_state0_elImage_fill_full964740336 = (input) => {
      return input.state || 1;
    
    }
    
    let transformValue_type_state0_elImage_fill_full964740336 = (input) => {
      let getContenantById = (id) => {
        return this.props.appActions.dataSheets['group_contenants'].items.find(it => it.document_key == id);
      }
      
      let getFluxByMatiere = (matiere) => {
        return this.props.appActions.dataSheets['matieres'].items.find(it => it.matiere == matiere);
      }
      
      let getMaterialByType = (type) => {
        return this.props.appActions.dataSheets['materiels'].items.find(it => it.type == type);
      }
      
      if (input.container_id == "null") {
        let type = (getMaterialByType(input.flux)||{}).code_shape||"30";
        return type;
      } else {
        let contenant = getContenantById(input.container_id) || {};
        let type = (getMaterialByType(contenant.type)||{}).code_shape||"30";
        return type;
      }
    }
    
    let transformValue_color_state0_elImage_fill_full964740336 = (input) => {
      let getContenantById = (id) => {
        return this.props.appActions.dataSheets['group_contenants'].items.find(it => it.document_key == id);
      }
      
      let getFluxByMatiere = (matiere) => {
        return this.props.appActions.dataSheets['matieres'].items.find(it => it.matiere == matiere);
      }
      
      let getMaterialByType = (type) => {
        return this.props.appActions.dataSheets['materiels'].items.find(it => it.type == type);
      }
      
      return (getFluxByMatiere(input.flux)||{}).color || "#000000";
    }
    const style_state0_elCard_outer = {
      backgroundColor: 'white',
      filter: 'drop-shadow(0.0px 2.3px 18px rgba(0, 0, 0, 0.1600))',
      overflow: 'visible',
     };
    
    let selection_exutoire_select = this.state.exutoire_select;
    // Source datasheet and selected data column for picker element 'exutoire_select'
    const dataSource_exutoire_select = this.props.appActions.getDataSheet('exutoires');
    const valueColumnName_exutoire_select = 'document_key';
    const labelColumnName_exutoire_select = 'label';
    
    const style_state0_elExutoire_select = {
      pointerEvents: 'auto',
     };
    const style_state0_elCard1_outer = {
      backgroundColor: 'white',
      filter: 'drop-shadow(0.0px 2.3px 18px rgba(0, 0, 0, 0.1600))',
      overflow: 'visible',
     };
    const style_state0_elImage = {
      backgroundImage: 'url('+((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_saved_picture'] : '') || img_state0_elImage)+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'contain',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_state0_elErase = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_405901650+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const state0_elErase = this.state.state0_elErase_visible ? (
      <div className="state0_elErase">
        <button className="actionFont" style={style_state0_elErase} onClick={this.onClick_state0_elErase}  />
      </div>
      
     ) : null;
    
    const style_state0_elCapture = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_644677+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '62.857%',
      paddingTop: '30%',
      backgroundPosition: '50% 0%',
      color: '#00e5d9',
      textAlign: 'center',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const state0_elCapture = this.state.state0_elCapture_visible ? (
      <div className="state0_elCapture">
        <button className="actionFont" style={style_state0_elCapture} onClick={this.onClick_state0_elCapture} >
          Ticket de pesée
        </button>
      </div>
      
     ) : null;
    
    const value_tonnage = (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_tonnage'] : '');
    
    const style_state0_elTonnage = {
      display: 'block',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      textAlign: 'left',
      pointerEvents: 'auto',
     };
    
    const value_commentaire = (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_commentaire'] : '');
    
    const style_state0_elCommentaire = {
      display: 'block',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      textAlign: 'left',
      pointerEvents: 'auto',
     };
    
    const style_state0_elValider = {
      display: 'block',
      textTransform: 'none',
      color: 'white',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_state0_elVidage_diff = {
      display: 'block',
      color: '#00e5d9',
      textAlign: 'center',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_state0_elBig_image = {
      backgroundImage: 'url('+((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_saved_picture'] : '') || img_state0_elBig_image)+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'contain',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const state0_elBig_image = this.state.state0_elBig_image_visible ? (
      <div className="state0_elBig_image" style={style_state0_elBig_image} onClick={this.onClick_state0_elBig_image}  />
     ) : null;
    
    const style_state0_elCancel1509691112 = {
      display: 'block',
      textTransform: 'none',
      color: '#fff',
      textAlign: 'left',
      backgroundColor: '#ff7d78',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_state0_elShow_apercu212082506 = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_212082506+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    let transformPropValue_notif = (input) => {
      let entreprise = this.props.appActions.dataSheets['entreprise'].items[0]||{};
      let auth_user = this.props.appActions.dataSheets['auth_user'].items[0] || {};
      let profile = auth_user.profile || {}; 
      
      if (entreprise.pvd_can_add_to_tour && (profile.hdq === true ? !entreprise.hdq_cannot_add_to_tour : true)) {
        let commands = this.props.appActions.dataSheets['tournees_j'].items
        .filter(it => it.tournee == "" && it.statut === 0)
        .sort((a,b) => a.display_name.localeCompare(b.display_name));
        if (commands.length > 0) {
          return "<p style='color:white;border-radius:100%;background-color:#ff7e79;width:18px;height:18px;'>"+commands.length+"</p>";
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
    
    const value_notif = transformPropValue_notif((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_today_minuit_ts'] : ''));
    
    const style_state0_elNotif815668831 = {
      fontSize: 12.3,
      color: '#feffff',
      textAlign: 'center',
      pointerEvents: 'auto',
     };
    const state0_elApercu245793648 = ((val) => { return val === "true" || val == true || val == 1 })((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_apercu_visible'] : '')) ? (
      <div className="hasNestedComps containerMinHeight state0_elApercu245793648">
        <Apercu visualStateIndex={(this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_mode_apercu'] : '')} ref={(el)=> this._state0_elApercu245793648 = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
      </div>
     ) : null;
    
    const value_tonnage_fg = (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_tonnage'] : '');
    
    const style_state0_elTonnage_fg = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      textAlign: 'left',
      pointerEvents: 'auto',
     };
    const state0_elTonnage_fg = this.state.state0_elTonnage_fg_visible ? (
      <input className="baseFont containerMinHeight state0_elTonnage_fg" style={style_state0_elTonnage_fg} type="number" placeholder="Tonnage" onChange={this.textInputChanged_state0_elTonnage_fg} value={value_tonnage_fg !== undefined ? value_tonnage_fg : ''}  />
     ) : null;
    
    const value_commentaire_fg = this.state.commentaire_fg;
    
    const style_state0_elCommentaire_fg = {
      display: 'block',
      backgroundColor: 'white',
      borderColor: 'lightGray',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    const state0_elCommentaire_fg = this.state.state0_elCommentaire_fg_visible ? (
      <textarea className="baseFont containerMinHeight state0_elCommentaire_fg" style={style_state0_elCommentaire_fg}  placeholder="Commentaire" onChange={this.textAreaChanged_state0_elCommentaire_fg} value={value_commentaire_fg !== undefined ? value_commentaire_fg : ''}  />
     ) : null;
    
    const style_state0_elSave_input = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_708131851+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const state0_elSave_input = this.state.state0_elSave_input_visible ? (
      <button className="actionFont state0_elSave_input" style={style_state0_elSave_input} onClick={this.onClick_state0_elSave_input}  />
     ) : null;
    
    return (
      <div className="AppScreen DétailVidageScreen" style={baseStyle}>
        <div className="background">
          <div className="containerMinHeight state0_elBackground1042437" style={style_state0_elBackground1042437_outer}>
            <div className="appBg" style={style_state0_elBackground1042437} />
          </div>
        </div>
        
        <div className="layoutFlow" style={layoutFlowStyle}>
          <div className="state0_elSpacer831938">
            <div />
          </div>
          
          <div className="state0_elExutoireCopy">
            <div className="headlineFont" style={style_state0_elExutoireCopy}>
              <div>{this.state.state0_elExutoireCopy}</div>
            </div>
          </div>
          
          <div className="state0_elRectangle1463615537">
            <div style={style_state0_elRectangle1463615537} />
          </div>
          
          <div className="flowRow flowRow_DétailVidageScreen_state0_elId_scan1649174831_1649174831">
          <div className="state0_elId_scan1649174831">
            <div className="baseFont" style={style_state0_elId_scan1649174831}>
              <div>{value_id_scan !== undefined ? value_id_scan : (<span className="propValueMissing">{this.state.state0_elId_scan1649174831}</span>)}</div>
            </div>
          </div>
          
          </div>
          <div className="hasNestedComps state0_elImage_fill_full964740336">
            <div>
              <Image_fill state={transformValue_state_state0_elImage_fill_full964740336((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} type={transformValue_type_state0_elImage_fill_full964740336((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} color={transformValue_color_state0_elImage_fill_full964740336((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} ref={(el)=> this._state0_elImage_fill_full964740336 = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
            </div>
          </div>
          
          <div className="flowRow flowRow_DétailVidageScreen_state0_elCard_1209029603">
          <div className="state0_elCard" style={style_state0_elCard_outer}>
            <div className="cardBg" />
          </div>
          
          <div className="state0_elExutoire_select">
            <Select className="baseFont" style={style_state0_elExutoire_select}  onChange={this.pickerValueChanged_state0_elExutoire_select} value={selection_exutoire_select} >
              {dataSource_exutoire_select.items.every(item => {
                return item[valueColumnName_exutoire_select] !== selection_exutoire_select;
              }) ? <Option value=''/> : null}
              {dataSource_exutoire_select.items.map(item => {
                const colValue = item[valueColumnName_exutoire_select];
                const labelColValue = item[labelColumnName_exutoire_select];
                return <Option key={item.key} value={colValue} label={labelColValue} />
              })}
            </Select>
          </div>
          
          </div>
          <div className="state0_elSpacer2">
            <div />
          </div>
          
          <div className="flowRow flowRow_DétailVidageScreen_state0_elCard1_1027341795">
          <div className="state0_elCard1" style={style_state0_elCard1_outer}>
            <div className="cardBg" />
          </div>
          
          <div className="state0_elImage">
            <div style={style_state0_elImage} onClick={this.onClick_state0_elImage}  />
          </div>
          
          { state0_elErase }
          { state0_elCapture }
          <div className="state0_elTonnage">
            <Input className="baseFont" style={style_state0_elTonnage} type="number" hint="Tonnage" onChange={this.textInputChanged_state0_elTonnage} value={value_tonnage !== undefined ? value_tonnage : ''}  />
          </div>
          
          <div className="state0_elCommentaire">
            <Input className="baseFont" style={style_state0_elCommentaire} type="text" hint="Commentaire" onChange={this.textInputChanged_state0_elCommentaire} value={value_commentaire !== undefined ? value_commentaire : ''}  />
          </div>
          
          </div>
          <div className="state0_elSpacer3">
            <div />
          </div>
          
          <div className="state0_elValider">
            <Button className="actionFont" style={style_state0_elValider}  color="accent" onClick={this.onClick_state0_elValider} >
              OUI
            </Button>
          </div>
          
          <div className="state0_elVidage_diff">
            <button className="actionFont" style={style_state0_elVidage_diff} onClick={this.onClick_state0_elVidage_diff} >
              NON, Vidage différe
            </button>
          </div>
        </div>
        <Appbar className="navBar">
          <div className="title">Vidage (Etape 3/4)</div></Appbar>
        
        <div className="screenFgContainer">
          <div className="foreground">
            { state0_elBig_image }
            <Button className="actionFont state0_elCancel1509691112" style={style_state0_elCancel1509691112}  variant="fab" onClick={this.onClick_state0_elCancel1509691112} >
              <img src={btn_icon_1509691112} alt="" style={{width: '100%', marginTop: '4%'}} />
            </Button>
            <button className="actionFont state0_elShow_apercu212082506" style={style_state0_elShow_apercu212082506} onClick={this.onClick_state0_elShow_apercu212082506}  />
            <div className="systemFontRegular  state0_elNotif815668831" style={style_state0_elNotif815668831}>
              <div><div dangerouslySetInnerHTML={{__html: value_notif}}></div></div>
            </div>
            { state0_elApercu245793648 }
            { state0_elTonnage_fg }
            { state0_elCommentaire_fg }
            { state0_elSave_input }
          </div>
        </div>
      </div>
    )
  }
  
  // --- Functions for component state index 1 (2 of 2) --- 
  
  onClick_state1_elTransfert = (ev) => {
    let a = window.confirm("Confirmer le transfert.");
    if (!a) {
      return;
    }
    
    let update_ot = {
      document_ref: this.props.appActions.dataSlots['ds_selected_command'].document_ref,
      document_key: this.props.appActions.dataSlots['ds_selected_command'].document_key,
      statut: 11,
    }
    
    this.props.appActions.updateDataSlot('ds_selected_command', {...this.props.appActions.dataSlots['ds_selected_command'], ...update_ot});
    this.props.appActions.dataSheets['tournees_j'].replaceItemByRowIndex(update_ot.document_key, update_ot, this.props.appActions.serviceOptions_tournees_j);
  
    // Go to screen 'depot v3'
    this.props.appActions.goToScreen('depotV3', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_state1_elCancel1509691112 = (ev) => {
    let a = window.confirm("Interrompre l'OT en cours?");
    if (!a) {
      return;
    }
  
    // Go to screen 'Tournée du jour'
    this.props.appActions.goToScreen('tournéeDuJour', { transitionId: 'fadeIn' });
  
  }
  
  
  onClick_state1_elShow_apercu212082506 = (ev) => {
    let newVal = "1";
    this.props.appActions.updateDataSlot('ds_apercu_visible', newVal);
  
  }
  
  
  renderState1() {
    let layoutFlowStyle = {};
    let baseStyle = {};
    if (this.props.transitionId && this.props.transitionId.length > 0 && this.props.atTopOfScreenStack && this.props.transitionForward) {
      baseStyle.animation = '0.25s ease-in-out '+this.props.transitionId;
    }
    if ( !this.props.atTopOfScreenStack) {
      layoutFlowStyle.height = '100vh';
      layoutFlowStyle.overflow = 'hidden';
    }
    
    const style_state1_elBackground1042437 = {
      width: '100%',
      height: '100%',
     };
    const style_state1_elBackground1042437_outer = {
      backgroundColor: '#f6f6f6',
     };
    const style_state1_elExutoireCopy = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'center',
     };
    
    const style_state1_elRectangle1463615537 = {
      background: 'rgba(213, 213, 213, 1.000)',
     };
    let transformPropValue_id_scan = (input) => {
      return input.id_scan||"";
    }
    let transformCustomCSSPropValue_id_scan = (input) => {
      let style = '"borderRadius": "5px"';
      try {
        let container = this.props.appActions.dataSheets['reference_containers'].items.find(it => it.id_scan === input.id_scan);
        if (container.unresolved_anomalies_labels.length) {
          style += ',"backgroundColor": "#FFD479"';
        } else {
          if (input.id_scan) {
            style += ',"backgroundColor": "#EBEBEB"';
          }
        } 
      } catch (e) {
        if (input.id_scan) {
          style += ',"backgroundColor": "#EBEBEB"';
        }
      }
      
      return style;
    }
    
    const value_id_scan = transformPropValue_id_scan((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
    
    const style_state1_elId_scan1649174831 = {
      color: 'rgba(0, 0, 0, 0.5000)',
      textAlign: 'center',
      ...(() => {  // append customCSS property of 'id_scan'
        let val = transformCustomCSSPropValue_id_scan((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''));
        if (val == null || val.length == 0) return null;
        try {
          return JSON.parse('{'+val+'}');
        } catch (error) {
          console.log(error);
        }
        return null;
      })(),
     };
    
    let transformValue_state_state1_elImage_fill_full964740336 = (input) => {
      return input.state || 1;
    
    }
    
    let transformValue_type_state1_elImage_fill_full964740336 = (input) => {
      let getContenantById = (id) => {
        return this.props.appActions.dataSheets['group_contenants'].items.find(it => it.document_key == id);
      }
      
      let getFluxByMatiere = (matiere) => {
        return this.props.appActions.dataSheets['matieres'].items.find(it => it.matiere == matiere);
      }
      
      let getMaterialByType = (type) => {
        return this.props.appActions.dataSheets['materiels'].items.find(it => it.type == type);
      }
      
      if (input.container_id == "null") {
        let type = (getMaterialByType(input.flux)||{}).code_shape||"30";
        return type;
      } else {
        let contenant = getContenantById(input.container_id) || {};
        let type = (getMaterialByType(contenant.type)||{}).code_shape||"30";
        return type;
      }
    }
    
    let transformValue_color_state1_elImage_fill_full964740336 = (input) => {
      let getContenantById = (id) => {
        return this.props.appActions.dataSheets['group_contenants'].items.find(it => it.document_key == id);
      }
      
      let getFluxByMatiere = (matiere) => {
        return this.props.appActions.dataSheets['matieres'].items.find(it => it.matiere == matiere);
      }
      
      let getMaterialByType = (type) => {
        return this.props.appActions.dataSheets['materiels'].items.find(it => it.type == type);
      }
      
      return (getFluxByMatiere(input.flux)||{}).color || "#000000";
    }
    
    const style_state1_elTransfert = {
      display: 'block',
      textTransform: 'none',
      color: 'white',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_state1_elCancel1509691112 = {
      display: 'block',
      textTransform: 'none',
      color: '#fff',
      textAlign: 'left',
      backgroundColor: '#ff7d78',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    const style_state1_elShow_apercu212082506 = {
      display: 'block',
      backgroundImage: 'url('+btn_icon_212082506+')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
      backgroundPosition: '50% 0%',
      color: '(null)',
      textAlign: 'left',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    let transformPropValue_notif = (input) => {
      let entreprise = this.props.appActions.dataSheets['entreprise'].items[0]||{};
      let auth_user = this.props.appActions.dataSheets['auth_user'].items[0] || {};
      let profile = auth_user.profile || {}; 
      
      if (entreprise.pvd_can_add_to_tour && (profile.hdq === true ? !entreprise.hdq_cannot_add_to_tour : true)) {
        let commands = this.props.appActions.dataSheets['tournees_j'].items
        .filter(it => it.tournee == "" && it.statut === 0)
        .sort((a,b) => a.display_name.localeCompare(b.display_name));
        if (commands.length > 0) {
          return "<p style='color:white;border-radius:100%;background-color:#ff7e79;width:18px;height:18px;'>"+commands.length+"</p>";
        } else {
          return '';
        }
      } else {
        return '';
      }
    }
    
    const value_notif = transformPropValue_notif((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_today_minuit_ts'] : ''));
    
    const style_state1_elNotif815668831 = {
      fontSize: 12.3,
      color: '#feffff',
      textAlign: 'center',
      pointerEvents: 'auto',
     };
    const state1_elApercu245793648 = ((val) => { return val === "true" || val == true || val == 1 })((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_apercu_visible'] : '')) ? (
      <div className="hasNestedComps containerMinHeight state1_elApercu245793648">
        <Apercu visualStateIndex={(this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_mode_apercu'] : '')} ref={(el)=> this._state1_elApercu245793648 = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
      </div>
     ) : null;
    
    return (
      <div className="AppScreen DétailVidageScreen" style={baseStyle}>
        <div className="background">
          <div className="containerMinHeight state1_elBackground1042437" style={style_state1_elBackground1042437_outer}>
            <div className="appBg" style={style_state1_elBackground1042437} />
          </div>
        </div>
        
        <div className="layoutFlow" style={layoutFlowStyle}>
          <div className="state1_elSpacer831938">
            <div />
          </div>
          
          <div className="state1_elExutoireCopy">
            <div className="headlineFont" style={style_state1_elExutoireCopy}>
              <div>{this.state.state1_elExutoireCopy}</div>
            </div>
          </div>
          
          <div className="state1_elRectangle1463615537">
            <div style={style_state1_elRectangle1463615537} />
          </div>
          
          <div className="flowRow flowRow_DétailVidageScreen_state1_elId_scan1649174831_1649174831">
          <div className="state1_elId_scan1649174831">
            <div className="baseFont" style={style_state1_elId_scan1649174831}>
              <div>{value_id_scan !== undefined ? value_id_scan : (<span className="propValueMissing">{this.state.state1_elId_scan1649174831}</span>)}</div>
            </div>
          </div>
          
          </div>
          <div className="hasNestedComps state1_elImage_fill_full964740336">
            <div>
              <Image_fill state={transformValue_state_state1_elImage_fill_full964740336((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} type={transformValue_type_state1_elImage_fill_full964740336((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} color={transformValue_color_state1_elImage_fill_full964740336((this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_selected_command'] : ''))} ref={(el)=> this._state1_elImage_fill_full964740336 = el} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />
            </div>
          </div>
          
          <div className="state1_elTransfert">
            <Button className="actionFont" style={style_state1_elTransfert}  color="accent" onClick={this.onClick_state1_elTransfert} >
              Transfert
            </Button>
          </div>
        </div>
        <Appbar className="navBar">
          <div className="title">Vidage (Etape 3/4)</div></Appbar>
        
        <div className="screenFgContainer">
          <div className="foreground">
            <Button className="actionFont state1_elCancel1509691112" style={style_state1_elCancel1509691112}  variant="fab" onClick={this.onClick_state1_elCancel1509691112} >
              <img src={btn_icon_1509691112} alt="" style={{width: '100%', marginTop: '4%'}} />
            </Button>
            <button className="actionFont state1_elShow_apercu212082506" style={style_state1_elShow_apercu212082506} onClick={this.onClick_state1_elShow_apercu212082506}  />
            <div className="systemFontRegular  state1_elNotif815668831" style={style_state1_elNotif815668831}>
              <div><div dangerouslySetInnerHTML={{__html: value_notif}}></div></div>
            </div>
            { state1_elApercu245793648 }
          </div>
        </div>
      </div>
    )
  }
  
  
  render() {
    let transformStateValue = (input) => {
      // This function modifies the state value of screen 'Détail vidage'.
      // There is a variable named 'input' that provides the state value.
      // The function must return an integer.
      //
      return input.hh === 'VIDE' ? 1 : 0;
    }
    switch (parseInt((transformStateValue(this.props.ds_selected_command) !== undefined) ? transformStateValue(this.props.ds_selected_command) : 0, 10)) {
      default:
      case 0:
        return this.renderState0();
      case 1:
        return this.renderState1();
    }
  }
  
}
